import React from 'react'
import CircleItem from '../circle-item/circle-item'
import styled from 'styled-components'

const ContainerRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
`

const NullDiv = styled.div`
  width: 35px;
  height: 35px;
`

interface IOwnProps{
  row1: string | number | null
  row2: string | number | null
  row4: string | number | null
  row3: string | number | null
  row5: string | number | null
}

const RowItemBus: React.FunctionComponent<IOwnProps> = ({ row1, row2, row3, row4, row5 }) => {
  return (
    <ContainerRow>
      {(row1 !== null) ?
        <CircleItem text={typeof row1 != 'number' ? null : row1} icon={typeof row1 === 'string' ? row1 : null}/>
        : <NullDiv />
      }
      {(row2 !== null) ?
        <CircleItem text={typeof row2 != 'number' ? null : row2} icon={typeof row2 === 'string' ? row2 : null}/>
        : <NullDiv />
      }
      {(row3 !== null) ? 
        <CircleItem text={typeof row3 != 'number' ? null : row3} icon={typeof row3 === 'string' ? row3 : null}/>
        : <NullDiv />
      }
      {(row4 !== null) ?
        <CircleItem text={typeof row4 != 'number' ? null : row4} icon={typeof row4 === 'string' ? row4 : null}/>
        : <NullDiv />
      }
      {(row5 !== null) ?
        <CircleItem text={typeof row5 != 'number' ? null : row5} icon={typeof row5 === 'string' ? row5 : null}/>
        : <NullDiv />
      }
    </ContainerRow>
  )
}

export default RowItemBus